import { Component, OnInit } from '@angular/core';
import { GoogleAuthService } from '@services/dws/google-auth.service';
import { FragmentBase, FragmentInjectable } from '../fragment-base';

@Component({
  selector: 'web-gmail-connection',
  templateUrl: './gmail-connection.component.html',
  styleUrls: ['./gmail-connection.component.scss'],
})
export class GmailConnectionComponent extends FragmentBase implements OnInit {

  constructor(
    private googleAuthService: GoogleAuthService,
    private injector: FragmentInjectable,
  ) {
    super(injector);
  }

  ngOnInit() {}

  get isLinked() {
    return !!this.wineryIntegration &&
    this.wineryIntegration.connected &&
    this.wineryIntegration.integrationData && (
      !this.wineryIntegration.integrationData.array ||
      !!this.wineryIntegration.integrationData.array[this.index]
    );
  }

  public get connectEnabled() {
    return !this.isLinked && !this.removeEnabled;
  }

  public get removeEnabled() {
    return !!this.wineryIntegration &&
    this.wineryIntegration.integrationData &&
    this.wineryIntegration.integrationData.array &&
    !!this.wineryIntegration.integrationData.array[this.index];
  }

  public async connect() {
    const credentials = await this.googleAuthService.authorizeForGmail().toPromise();
    if (credentials.error == "popup_closed_by_user") return;
    return credentials;
  }

  clickHandler() {
    this.clickEventSubject.next({
      type: GmailConnectionComponent,
      index: this.index,
      action: 'connect'
    });
  }
}
